<template>
  <div class="layout_aside">
    <el-menu
      router
      :collapse="isCollapse"
      :default-active="activeMenu"
      background-color="#001529"
      text-color="#fff"
      active-text-color="#2d8cf0"
      @click="handleMenuClick"
      :unique-opened="true"
      :collapse-transition="true"
    >
      <!-- $route.path -->
      <el-menu-item index="/home">
        <img src="@/assets/img/menu_home.png" class="menu_icon" />
        <template #title>首页</template>
      </el-menu-item>
      <el-sub-menu
        v-for="(item, index) in menuList"
        :key="index"
        :index="index + ''"
      >
        <template #title>
          <img :src="item.meta.icon" class="menu_icon" />
          <span>{{ item.meta.title }}</span>
        </template>
        <el-menu-item
          v-for="(ele, i) in item.children"
          :key="i"
          :index="ele.path"
          @click="handleMenuItem(ele)"
          >{{ ele.meta.title }}</el-menu-item
        >
      </el-sub-menu>
    </el-menu>
  </div>
</template>

<script setup>
import { onMounted, ref, onUnmounted, computed } from "vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { authorityTreeData } from "@/api/index";
import { setStorage, getStorage, removeStorage } from "@/utils";

const store = useStore();
let router = useRouter(); //路由
const route = useRoute();
// 接受父组件传来的值
const props = defineProps(["isCollapse"]);
const emit = defineEmits(["toggle-collapse"]);
const menuList = ref([]); //菜单列表
const activeMenu = computed(() => {
  const { meta, path } = route;
  // 如果有设置activeMenu，则使用它，否则使用当前路由path
  return meta.activeMenu || path;
});
onMounted(() => {
  let menuTreeMetaVos = getStorage("menuTreeMetaVos");
  // console.log(menuTreeMetaVos, "menuTreeMetaVos");
  menuTreeMetaVos.forEach((item) => {
    // console.log(item, "icon");
    item.meta.icon = item.meta.icon
      ? require(`@/assets/img/${item.meta.icon}`)
      : "";
  });
  menuList.value = menuTreeMetaVos;
  console.log(menuList.value, "菜单列表");
  // authorityTreeData()
  //   .then((res) => {
  //     res.data.forEach((item) => {
  //       item.icon = require(`@/assets/img/${item.icon}.png`);
  //     });
  //     menuList.value = res.data;
  //   })
  //   .catch((err) => {
  //     ElMessage({
  //       message: err,
  //       type: "error",
  //     });
  //   });
});
const handleMenuClick = (data) => {
  console.log(data, "item菜单=======");
  // setStorage("MENU_TABS", []);
};
const handleMenuItem = (data) => {
  console.log(data, "当前点击菜单=======");
  let obj = {
    name: data.meta.title,
    url: data.path,
  };
  let tabs = getStorage("MENU_TABS") ? getStorage("MENU_TABS") : [];
  tabs.push(obj);
  const uniTabs = tabs.filter(
    (item, index, self) => index === self.findIndex((t) => t.url === item.url)
  );
  console.log(tabs, "tabs", uniTabs);
  setStorage("MENU_TABS", uniTabs);
};
</script>

<style lang="scss" scoped>
.layout_aside {
  width: 100%;
  height: 100%;
  background-color: #001529;
  :deep(.el-menu)  {
    height: 100%;
    width: 100%;
    overflow: auto;
    background-color: transparent;
    border: none;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
   :deep(.el-menu-item),
   :deep(.el-sub-menu__title){
    color: #fff !important;
  }
  ::v-deep .el-menu-item:hover,
  ::v-deep .el-sub-menu__title:hover {
    background-color: #464444 !important; /* 替换为你想要的颜色 */
  }
  ::v-deep .el-menu-item.is-active {
    background-color: #2d8cf0 !important;
    color: #fff;
  }
  .menu_icon {
    width: 20px;
    margin-right: 10px;
  }
}
/* 解决折叠时图标不居中问题 */
// .el-menu--collapse .el-sub-menu__title span,
// .el-menu--collapse .el-menu-item span {
//   height: 0;
//   width: 0;
//   overflow: hidden;
//   visibility: hidden;
//   display: inline-block;
// }
</style>